module.exports = __webpack_public_path__ + "img/feedback1.755addb7.webp";